import React from 'react'
import './styles.scss'

const AchievementCard = (props) => {
  return (
    <div className="card-achievement">
      {props.AchievementData.map((item, index) => (
        <div key={index} className="main-card-achievement">
          <div className="img-content-achievement">
            <div className="frame-img-achievement">
              <img src={item.img} alt="" />
            </div>
            <div className="content-achievement">
              <h6>{item.title}</h6>
              <p>{item.content}</p>
            </div>
          </div>
        </div>
      ))}
    </div>
  )
}

export default AchievementCard
